import axios from '@/axios.config.js';

class SchoolService {
    listSchools(cancelToken) {
        return axios
            .get('schools', {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    createSchool(cancelToken, school) {
        return axios
            .post('schools', school, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    updateSchool(cancelToken, schoolId, school) {
        return axios
            .patch(`schools/${schoolId}`, school, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }

    deleteSchool(cancelToken, schoolId) {
        return axios
            .delete(`schools/${schoolId}`, {cancelToken: cancelToken.token})
            .then(response => {
                return response.data;
            });
    }
}

export default new SchoolService();